import CurrenciesService from '@/services/codebooks/CurrenciesService'

export default {
  namespaced: true,
  state: {
    currenciesList: []
  },
  getters: {
    currenciesList: state => state.currenciesList
  },
  actions: {
    refreshCurrencies ({ commit }) {
      return CurrenciesService.getAllCurrencies()
        .then(list => {
          commit('SET_CURRENCIES', list)
        })
    }
  },
  mutations: {
    SET_CURRENCIES (state, list) {
      state.currenciesList = list
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/codebook/currencies.js